import { PolicyStatus } from '@/api/policy-status/policy-status';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown, Download, Eye } from 'lucide-react';

import { UpdatePolicyStatus } from './sheet-update';

export const columns: ColumnDef<PolicyStatus>[] = [
	{
		accessorKey: 'amsStatus',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				AMS Status
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div className="whitespace-nowrap font-medium">
					{row.original.amsStatus}
				</div>
			);
		},
	},
	{
		accessorKey: 'mappedStatus',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Mapped Status
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div className="whitespace-nowrap font-medium">
					{row.original.mappedStatus}
				</div>
			);
		},
	},
	{
		accessorKey: 'description',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Description
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div className="whitespace-nowrap font-medium">
					{row.original.description}
				</div>
			);
		},
	},
	{
		accessorKey: 'isPrimaryStatus',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Primary Status
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center">
					<Checkbox checked={!!row.original.isPrimaryStatus} disabled />
				</div>
			);
		},
	},
	{
		accessorKey: 'isExpired',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Expired
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center">
					<Checkbox checked={!!row.original.isExpired} disabled />
				</div>
			);
		},
	},
	{
		accessorKey: 'databaseInstanceName',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Database Instance
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center whitespace-nowrap font-medium">
					{row.original.databaseInstanceName}
				</div>
			);
		},
	},
	{
		id: 'actions',
		cell: ({ row }) => (
			<div>{<UpdatePolicyStatus policyStatus={row.original} />}</div>
		),
	},
];
